import { useEffect } from 'react'

export function useScrollLock(lock: boolean) {
  useEffect(() => {
    if (lock) {
      document.documentElement.classList.add('scroll-locked')
      document.body.classList.add('scroll-locked')
    } else {
      document.documentElement.classList.remove('scroll-locked')
      document.body.classList.remove('scroll-locked')
    }

    return () => {
      document.documentElement.classList.remove('scroll-locked')
      document.body.classList.remove('scroll-locked')
    }
  }, [lock])
}
